/*
 * Copyright (c) 2024-2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import { useEffect } from 'react'
import { useAppDispatch } from 'helpers/store'
import { setRemindersContext } from 'store/ui/UiReducer'

export const useHeadbarReminders = (
    isVisible: boolean,
    modelName?: string,
    modelId?: number
) => {
    const dispatch = useAppDispatch()

    useEffect(() => {
        if (isVisible && modelName && modelId) {
            dispatch(
                setRemindersContext({
                    isVisible,
                    modelName,
                    modelId,
                })
            )
        } else {
            dispatch(setRemindersContext(null))
        }

        return () => {
            dispatch(setRemindersContext(null))
        }
    }, [dispatch, isVisible, modelName, modelId])
}
